import { type OcrResult } from "@finway-group/shared/lib/models"
import { roundNumberTo2Decimals } from "@finway-group/shared/lib/utils"
import { Col, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { SectionHeader, TableHeader } from "~Components/einvoice/components/shared"

interface ItemsProps {
    data: OcrResult
}

export const EInvoiceItems = ({ data }: ItemsProps) => {
    const { t } = useTranslation()
    if (!data.eInvoiceData?.invoiceLines) {
        return null
    }

    return (
        <>
            <SectionHeader title={t("label:itemized_charges")} />
            <TableHeader
                columns={[
                    { span: 2, label: t("label:position") },
                    { span: 7, label: t("label:description") },
                    { span: 4, label: t("label:net_price") },
                    { span: 3, label: t("label:qty") },
                    { span: 4, label: t("label:vat_rate") },
                    { span: 4, label: t("label:gross_price"), textAlign: "right" },
                ]}
            />
            <div className="border-1 border-gray-200 font-medium text-xs space-y-8 rounded-sm">
                {data.eInvoiceData.invoiceLines.map((invoiceLine: any, index: number) => (
                    <Row key={invoiceLine.lineId} className={`p-10 px-14 text-black ${index !== data.eInvoiceData!.invoiceLines.length - 1 ? "border-b-1 border-gray-200" : ""}`}>
                        <Col span={2} className="font-thin">
                            <span>{invoiceLine.lineId}</span>
                        </Col>
                        <Col span={6}>
                            <span>{invoiceLine.name}</span>
                        </Col>
                        <Col span={4} offset={1}>
                            <span>{roundNumberTo2Decimals(invoiceLine.itemPrice)}</span>
                        </Col>
                        <Col span={3}>
                            <span>{invoiceLine.invoicedQuantity}</span>
                        </Col>
                        <Col span={4}>
                            <span>{invoiceLine.taxCategoryPercent}%</span>
                        </Col>
                        <Col span={4} className="text-right">
                            <span>{roundNumberTo2Decimals(invoiceLine.lineExtensionAmount)}</span>
                        </Col>
                    </Row>
                ))}
            </div>
        </>
    )
}
